import { render, staticRenderFns } from "./ResetTradingPassword.vue?vue&type=template&id=c2c3a93c"
import script from "./ResetTradingPassword.vue?vue&type=script&lang=js"
export * from "./ResetTradingPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports